export default __webpack_public_path__ + "static/media/remove.23b891d5.svg";